import { useCallback } from 'react';
import { usePageAction } from '@repo/hooks/usePageAction';
import type { ElementViewedContextValue } from '@repo/segment/Analytics/ElementViewed';

export const useCustomAboveSectionsToggleHandlers = (
  idSuffix: string,
  fireElementInteracted: ElementViewedContextValue['fireElementInteracted'],
) => {
  // TODO: Segment Standardization Cleanup
  const fireReadMorePageAction = usePageAction({
    actionName: 'simplified_ru_read_more',
    actionSection: 'banking',
  });

  // TODO: Segment Standardization Cleanup
  const fireReadLessPageAction = usePageAction({
    actionName: 'simplified_ru_show_less',
    actionSection: 'banking',
  });

  const handleReadMoreClick = useCallback(() => {
    fireReadMorePageAction();
    fireElementInteracted('expand', {
      entityName: 'simplified_ru_read_more',
    });
  }, [fireReadMorePageAction, fireElementInteracted]);

  const handleReadMoreKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        fireReadMorePageAction();
        fireElementInteracted('expand', {
          entityName: 'simplified_ru_read_more',
        });
        const checkbox = document?.getElementById(`checkbox-toggle-${idSuffix}`);
        checkbox?.click();
        requestAnimationFrame(() => {
          checkbox?.parentElement?.querySelector<HTMLElement>('.read-less-container')?.focus();
        });
      }
    },
    [fireReadMorePageAction, fireElementInteracted, idSuffix],
  );

  const handleReadLessClick = useCallback(() => {
    fireReadLessPageAction();
    fireElementInteracted('collapse', {
      entityName: 'simplified_ru_show_less',
    });
  }, [fireReadLessPageAction, fireElementInteracted]);

  const handleReadLessKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        fireReadLessPageAction();
        fireElementInteracted('collapse', {
          entityName: 'simplified_ru_show_less',
        });
        const checkbox = document?.getElementById(`checkbox-toggle-${idSuffix}`);
        checkbox?.click();
        requestAnimationFrame(() => {
          checkbox?.parentElement?.querySelector<HTMLElement>('.read-more-label')?.focus();
        });
      }
    },
    [fireReadLessPageAction, fireElementInteracted, idSuffix],
  );

  return {
    handleReadMoreClick,
    handleReadMoreKeyDown,
    handleReadLessClick,
    handleReadLessKeyDown,
  };
};
